/**
 * The signature ritual — full-bleed dark block.
 *
 * Client correction (Sep 2026): no price and no booking CTA here — The
 * Works is bought from the menu row, and this section only makes the case
 * for it. The works copy keys for the old price/CTA stay per the add-only
 * rule.
 *
 * The left panel runs the wide shop photo — pool table centred, chairs on
 * both walls, hex ceiling — under a bottom-weighted gradient that keeps the
 * caption legible. A photo of the actual service can replace it later; the
 * gradient and caption already assume a photograph behind them.
 */

import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';
import { photoManifest } from '@/lib/photoManifest';

export default function WorksFeature() {
  const c = useCopy().home.works;
  const { t } = useShopConfig();

  return (
    <section className="grid grid-cols-1 lg:grid-cols-[1.06fr_0.94fr]">
      <div className="relative min-h-[320px] overflow-hidden bg-navy lg:min-h-[620px]">
        <picture className="absolute inset-0">
          <source
            srcSet={`${photoManifest.shopWide.hero.src} 2400w, ${photoManifest.shopWide.med.src} 1400w`}
            sizes="(min-width: 1024px) 50vw, 100vw"
            type="image/webp"
          />
          <img
            src={photoManifest.shopWide.fallback.src}
            alt={photoManifest.shopWide.alt}
            className="h-full w-full object-cover object-center"
            width={photoManifest.shopWide.fallback.width}
            height={photoManifest.shopWide.fallback.height}
            loading="lazy"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" />
      </div>

      <div className="flex flex-col justify-between bg-navy p-8 text-paper md:p-10 lg:p-16">
        <div>
          <h2 className="mt-8 font-newsreader text-[42px] font-medium leading-[0.92] tracking-[-0.03em] md:text-[64px]">
            {t(c.headlineLine1)}
            <br />
            <em className="font-normal text-gold">{t(c.headlineLine2)}</em>
          </h2>
          <p className="mt-8 max-w-[440px] font-newsreader text-[19px] leading-[1.6] text-paper/70">
            {t(c.ritualBody)}
          </p>
        </div>

      </div>
    </section>
  );
}
